<template>
    <div class="scc-container">
        <div class="scc-container__row">
            <div class="scc-container__column scc-container__lg-offset--2 scc-container__lg-column--8">
                <div class="knvb-check-order">
                    <template>
                        <h1 class="knvb-check-order__title">{{ title }}</h1>
                        <div class="knvb-check-order__content">
                            <template v-if="orderStatus === 'pending'">
                                <div class="knvb-check-order__spinner"></div>
                            </template>
                            <p class="knvb-check-order__text">{{ text }}</p>
                            <SccLink
                                v-if="showBackButton"
                                class="knvb-check-order__back-button"
                                to="home"
                                color="primary"
                                align="center"
                                button
                                large
                                inverted
                            >
                                {{ backButtonText }}
                            </SccLink>
                        </div>
                    </template>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import './knvb-check-order.scss';

import { api } from '@/services/api';
import { order as OrderQuery } from '@/services/api/queries';
import { deleteFromSessionStorage } from '@/utils/storage';

export default {
    name: 'KnvbCheckOrder',
    components: {},
    __editor: {
        fields: {
            checkStatus: {
                widget: 'select',
                values: ['pending', 'paid', 'cancelled', 'refunded', 'charged_back'],
            },
            backgroundColor: {
                widget: 'select',
                values: ['white', 'grey', 'primary', 'secondary'],
            },
            padding: {
                widget: 'select',
                values: ['none', 'small', 'medium', 'large'],
            },
        },
        requiredData: ['game'],
    },
    props: {
        game: {
            type: Object,
            required: true,
        },
        checkStatus: {
            type: String,
            default: 'pending',
            validator: function(val) {
                return ['pending', 'paid', 'cancelled', 'refunded', 'charged_back'].includes(val);
            },
        },
        loadingTitle: {
            type: String,
            default: 'Je aankoop wordt gecontroleerd',
        },
        loadingText: {
            type: String,
            default: 'Een moment geduld alsjeblieft, we controleren nu je betaling...',
        },
        errorTitle: {
            type: String,
            default: 'Er is iets fout gegaan',
        },
        errorText: {
            type: String,
            default:
                'Het lukt ons nu niet om je betaling te verifiëren. Controleer de inbox en spam folder van het door jou opgegeven e-mailadres. Heb je geen mailtje van ons ontvangen en is er geen geld afgeschreven, probeer het dan opnieuw.',
        },
        successTitle: {
            type: String,
            default: 'Bedankt voor je steun',
        },
        successText: {
            type: String,
            default:
                'Bedankt voor jouw deelname aan de Amateurvoetbal loterij. Je ontvangt zo een bevestigingsmail met informatie over je lot(en).',
        },
        failedTitle: {
            type: String,
            default: 'De aankoop is mislukt',
        },
        failedText: {
            type: String,
            default: 'De betaling is helaas niet gelukt, probeer het opnieuw.',
        },
        backButtonText: {
            type: String,
            default: 'Terug',
        },
    },
    data() {
        return {
            orderStatus: 'pending',
            order: null,
            retries: 0,
            maxRetries: 10,
            timeoutId: null,
        };
    },
    computed: {
        title() {
            switch (this.orderStatus) {
                case 'paid':
                    return this.successTitle;
                case 'cancelled':
                case 'refunded':
                case 'charged_back':
                    return this.failedTitle;
                case 'error':
                    return this.errorTitle;

                default:
                    return this.loadingTitle;
            }
        },
        text() {
            switch (this.orderStatus) {
                case 'paid':
                    return this.successText;
                case 'cancelled':
                case 'refunded':
                case 'charged_back':
                    return this.failedText;
                case 'error':
                    return this.errorText;

                default:
                    return this.loadingText;
            }
        },
        orderStatusIsSuccessful() {
            const statuses = ['paid'];
            return statuses.includes(this.orderStatus);
        },
        showBackButton() {
            const statuses = ['cancelled', 'refunded', 'charged_back', 'error'];
            return statuses.includes(this.orderStatus);
        },
    },
    created() {
        this.orderStatus = this.checkStatus;
    },
    beforeDestroy() {
        clearTimeout(this.timeoutId);
    },
    mounted() {
        this.getOrder();
        if (this.$route && this.$route.query && this.$route.query.order_id) {
            this.getOrder();
        }
    },
    methods: {
        async getOrder() {
            const data = { query: OrderQuery, variables: { orderId: this.$route.query.order_id } };

            try {
                await api
                    .post('', data)
                    .then(
                        ({
                            data: {
                                data: { order },
                            },
                        }) => {
                            console.log(order);
                            if (!order) {
                                throw Error('Order not found');
                            }

                            const { status } = order;

                            if (status === 'pending') {
                                this.orderStatus = 'pending';
                                this.retry(this.getOrder);
                                return;
                            } else if (status === 'paid') {
                                deleteFromSessionStorage('registrationForm');
                            }

                            this.order = order;
                            this.orderStatus = status;
                        }
                    )
                    .catch(e => {
                        console.error(e);
                        this.orderStatus = 'error';
                    });
            } catch (err) {
                this.orderStatus = 'error';
            }
        },
        retry(fn) {
            this.timeoutId = setTimeout(() => {
                if (this.retries < this.maxRetries) {
                    this.retries += 1;
                    fn();
                }
            }, 3000 + this.retries * 1000);
        },
    },
};
</script>
